<template>
  <div class="wrapchat">
    <div style="height: 50px" class="livehead">
      <div>{{ userid }}</div>
    </div>
    <div id="chatbox" class="pb-3" style="flex-grow: 1; overflow: auto; position: relative">
      <div class="pa-3 chatboxinside">
        <transition-group name="list" tag="div">
          <div v-for="(message, k) in messages" :key="k" :class="`messageitem-` + message.actor">
            <template v-if="message.text !== 'zwiz_welcome'">
              <div :class="message.actor == 'answer' ? `mr-2` : 'ml-2'">
                <v-avatar size="40px" color="#efefef">
                  <!-- <v-icon v-if="message.type == 'question'" size="30px"
                      >mdi-face-agent</v-icon
                    > -->
                  <v-img v-if="message.actor == 'answer'" src="../assets/mitsuicon.png"></v-img>
                  <v-icon color="grey" v-else size="30px">mdi-account</v-icon>
                </v-avatar>
              </div>
              <div>
                <message-bubble
                  @sendMessage="sendMessage"
                  :message="message"
                  @showDivision="showDivision = true"
                />
              </div>
            </template>
          </div>
        </transition-group>
        <transition name="list">
          <div v-if="showToBottom" class="text-center tobottom">
            <v-btn @click="scrollToBottom" icon elevation="2" small>
              <v-icon>mdi-chevron-double-down</v-icon>
            </v-btn>
          </div>
        </transition>

        <div style="height: 40px"></div>
      </div>
    </div>
    <div>
      <div style="width: 100%" class="px-2">
        <v-card>
          <v-text-field
            @keyup.enter="
              sendMessage({
                title: input,
                payload: input
              })
            "
            hide-actions
            v-model="input"
            hide-details
            class="mb-0"
            placeholder="Type a message..."
            flat
            solo
          >
            <template v-slot:append>
              <v-btn
                @click="
                  sendMessage({
                    title: input,
                    payload: input
                  })
                "
                style="width: 70px"
                color="#d80000"
                dark
                >send</v-btn
              >
            </template></v-text-field
          >
        </v-card>
      </div>
      <div style="height: 20px"></div>
    </div>
    <perfect-scrollbar
      style="
          position: absolute;
          bottom: 70px;
          width: 100%;
          overflow-x: auto;
          height: 44px;
          overflow-y: hidden;
          display: flex;
          justify-content: left;
          align-items: flex-start
        "
      class="text-center"
    >
      <v-btn
        small
        @click="
          sendMessage({
            title: item,
            payload: item
          })
          quick_replies = ''
        "
        dense
        v-ripple
        style="
            background-color: white;
            border: 1px solid rgb(255 82 82);
            border-radius: 12px;
            color: #ff6666;
          "
        class="mx-2 px-3 text-capitalize"
        v-for="(item, k) in quick_replies"
        :key="k"
        >{{ item }}</v-btn
      >
    </perfect-scrollbar>
    <SelectDivision v-model="showDivision" @sendMessage="sendMessage" />
  </div>
</template>

<script>
import Chatbox from './Chatbox.js'
export default {
  mixins: [Chatbox]
}
</script>

<style lang="scss" scoped>
.messageitem-question {
  display: flex;
  margin-bottom: 16px;
  flex-direction: row-reverse;
}
.messageitem-answer {
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
}
.livehead {
  background-color: #ce1a26;
  color: white;
  padding: 13px;
}
.wrapchat {
  position: fixed;

  height: 100vh !important;
  height: -webkit-fill-available !important;
  display: flex;
  flex-direction: column;
  width: 100vw;
}

.list-item {
  display: inline-block;
  margin-right: 10px;
}
.list-enter-active,
.list-leave-active {
  transition: all 0.3s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(20px);
}

.tobottom {
  position: fixed;
  // transform: translate3d(0, 0, 0);
  bottom: 105px;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
